// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".answer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.answer .answer-name {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.answer .answer-name ion-checkbox {\n  --size: 20px;\n  opacity: 1;\n  --background-checked: #ccc;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
